(function () {
  angular
    .module('specsguardApp')
    .directive('widgetProjectInfo', widgetProjectInfo);

  function widgetProjectInfo () {
    return {
      controller: 'widgetProjectInfoCtrl',
      controllerAs: '$widgetProjectInfoCtrl',
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/info/widget-project-info.tmpl.html',
    };
  }

})();
